import type { LogLevelNames } from '@vp/ubik-fragment-types'

export const PAGE_DEPT = 'Home Page - V2'
export const PAGE_NAME = 'HomePage'
export const PAGE_STAGE = 'Discover'
export const REQUESTOR = 'homepage'

export const FEATURE_TILE_TRACKING_ZONE = 'Featured Tiles'

export const BANNER_PAGE_ZONES = {
  topBanner: 'Hero',
  middleBanner: 'Merchandising Section',
}

export const SEO_PAGE_ZONE = 'SEO Zone'

export const ANALYTICS_METADATA = {
  pageName: PAGE_NAME,
  pageSection: PAGE_NAME,
  pageStage: PAGE_STAGE,
  pageDept: PAGE_DEPT,
}

export const ONE_MINUTE_SECONDS = 60

/**
 * Returns a default logger config object for a given service name.
 * @param serviceName - The service name to use in the logger config.
 * @returns Logger config object with serviceName and logLevel.
 */
export function getDefaultLoggerConfig(serviceName: string) {
  return {
    serviceName,
    logLevel: (process.env['LOGGER_LEVEL'] || 'info') as LogLevelNames,
  }
}
